export default {
  CareQuilt: 'CareQuilt',
};
